import axios from 'axios'
import LoadingService from '@/utils/loadingManager'
import { getStorage } from '@/utils/storage'
import { STORAGE_KEYS } from '@/constants/storageKeys'
import ErrorHandler from '@/utils/errorHandler'
import { getAcceptLanguageForApi } from '@/utils/apiLocale'

// 创建 axios 实例
const getBaseURL = () => {
  const baseURL = process.env.VUE_APP_API_BASE_URL || ''
  return baseURL
}

const apiClient = axios.create({
  baseURL: getBaseURL(),
  timeout: 30000 // 30秒超时
})

// 请求拦截器
apiClient.interceptors.request.use(
  config => {
    // 启动 loading（支持 skipLoading 跳过）
    if (!config.skipLoading) {
      LoadingService.start()
    }
    
    // 添加 token
    const token = getStorage(STORAGE_KEYS.TOKEN)
    if (!config.headers) {
      config.headers = {}
    }
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    
    // 添加 App 来源标识，用于订单号前缀区分
    const appSource = getStorage(STORAGE_KEYS.APP_SOURCE)
    config.headers['X-App-Source'] = appSource || 'lesim'

    // 添加追踪 Client ID
    const clientId = getStorage(STORAGE_KEYS.CLIENT_ID)
    if (clientId) {
      config.headers['X-Client-Id'] = clientId
    }

    // 与界面语言一致：避免系统浏览器 Accept-Language（如 zh-CN）覆盖用户在应用内选的英文
    if (!config.headers['Accept-Language']) {
      config.headers['Accept-Language'] = getAcceptLanguageForApi()
    }
    
    return config
  },
  error => {
    // 出错也要结束 loading
    if (!error.config?.skipLoading) {
      LoadingService.end()
    }
    return Promise.reject(error)
  }
)

// 响应拦截器
apiClient.interceptors.response.use(
  response => {
    // 结束 loading（跳过 skipLoading 的请求）
    if (!response.config?.skipLoading) {
      LoadingService.end()
    }
    return response
  },
  error => {
    // 结束 loading
    if (!error.config?.skipLoading) {
      LoadingService.end()
    }
    
    // 统一错误处理
    return ErrorHandler.handle(error, {
      silent: error.config?.skipErrorHandler === true // 允许某些请求跳过错误处理
    })
  }
)

export default apiClient
